import { createRouter, createWebHashHistory } from 'vue-router';
import { useFormStore } from './stores/form.js';
import Step1 from './views/Step1.vue';
import Step2 from './views/Step2.vue';

/**
 * Create router instance
 * This function is called lazily when the Vue app is created,
 * not at module load time, to prevent router initialization on all pages.
 *
 * @return {Router} Vue Router instance
 */
export function createAppRouter() {
	const routes = [
		{
			path: '/',
			redirect: '/step/1',
		},
		{
			path: '/step/1',
			name: 'Step1',
			component: Step1,
		},
		{
			path: '/step/2',
			name: 'Step2',
			component: Step2,
			beforeEnter: ( to, from, next ) => {
				const store = useFormStore();
				if ( ! store.isStep1Completed ) {
					next( '/step/1' );
					return;
				}
				next();
			},
		},
	];

	const router = createRouter( {
		history: createWebHashHistory(),
		routes,
		scrollBehavior() {
			return {
				left: 0,
				top: 0,
			};
		},
	} );

	// Global navigation guard to prevent skipping steps
	router.beforeEach( ( to, from, next ) => {
		// Allow access to step 1 always
		if ( to.name === 'Step1' || to.path === '/' ) {
			next();
			return;
		}

		const store = useFormStore();

		// For step 2, check step 1
		if ( to.name === 'Step2' ) {
			if ( ! store.isStep1Completed ) {
				next( '/step/1' );
				return;
			}
			next();
			return;
		}

		// Allow other routes (fallback)
		next();
	} );

	return router;
}
